/* THIS FILE IS GENERATED. DO NOT EDIT */

import { PropsFromComponent } from '@/types/component';
import ErrorBoundary from 'base/components/ErrorBoundary';
import LabradorAffiliateGallery from 'base/components/labrador/AffiliateGallery';

export const DynamicLabradorAffiliateGallery: typeof LabradorAffiliateGallery = (props) => {
    return <ErrorBoundary><LabradorAffiliateGallery {...props} /></ErrorBoundary>;
}
export type DynamicLabradorAffiliateGalleryProps = PropsFromComponent<typeof LabradorAffiliateGallery>;
